import type { Localized } from '../types';

type CompanyRow = {
  readonly label: string;
  readonly value: string;
};

type AboutContent = {
  readonly heroTitle: string;
  readonly profileTitle: string;
  readonly profileMessage: readonly string[];
  readonly careerTitle: string;
  readonly careerHistory: readonly string[];
  readonly companyTitle: string;
  readonly companyInfo: readonly CompanyRow[];
  readonly signRole: string;
  readonly signName: string;
};

export const aboutDict: Localized<AboutContent> = {
  ja: {
    heroTitle: '会社概要',
    profileTitle: '代表紹介',
    profileMessage: [
      '私たちは、テクノロジーの進化によって、資産形成の在り方も大きく変化していく時代にあると考えています。情報が溢れ、相場変動も激しくなる中で、感情や経験だけに頼った投資判断には限界がある一方、AIやデータ分析を活用することで、より合理的な判断を支援できる可能性が広がっています。',
      'CJインベストメント株式会社では、AIを活用した運用支援と、金融知見に基づくウェルスマネジメントを組み合わせ、一人ひとりに寄り添った資産形成支援を目指しています。私たちは単にシステムを提供するのではなく、お客様が長期的に安心して資産形成に向き合える環境づくりを大切にしています。',
      'また、資産形成において本当に重要なのは、短期的な成果だけではなく、継続性や再現性、そして信頼できるパートナーの存在だと考えています。そのため、テクノロジーだけに依存するのではなく、人によるサポートやコミュニケーションも重視しながら、長期的な視点での支援を行っています。',
      'これからも、ITと金融の両面から価値提供を行い、変化の激しい時代においても、お客様に安心して選んでいただける存在を目指してまいります。',
    ],
    careerTitle: '経歴',
    careerHistory: [
      '1994年　山一證券に入社、債券部で先物OPディーラーを担当',
      '2007年　HSBC香港上海銀行に入社、個人金融本部で富裕層向け投資アドバイザーを担当',
      '2017年　CJインベストメント株式会社を設立',
    ],
    companyTitle: '企業情報',
    companyInfo: [
      {
        label: '会社名',
        value: 'CJインベストメント株式会社（英文名称：CJ Investment Corporation）',
      },
      {
        label: '所在地',
        value: '〒222-0033　神奈川県横浜市港北区新横浜2-5-4 京浜建物第2ビル504',
      },
      { label: '資本金', value: '1,000万円' },
      { label: '設立', value: '2017年1月' },
      { label: '従業員数', value: '3名（2022年7月現在）' },
      { label: '取引銀行', value: 'スルガ銀行、湘南信用金庫' },
    ],
    signRole: '代表取締役',
    signName: '李 松',
  },
  zh: {
    heroTitle: '公司简介',
    profileTitle: '代表介绍',
    profileMessage: [
      '我们认为，随着科技的进步，资产积累的方式也正处在大幅变化的时代。在信息泛滥、行情波动日益剧烈的当下，仅凭情绪与经验做出的投资判断已显现局限；而通过运用AI与数据分析，支持更为理性判断的可能性正不断拓展。',
      'CJ投资株式会社将运用AI的投资支持与基于金融洞见的财富管理相结合，致力于为每一位客户量身定制资产积累支持。我们并非单纯提供系统，而是重视为客户营造能够长期安心面对资产积累的环境。',
      '此外，我们认为在资产积累中真正重要的，不仅是短期成果，更在于持续性、可复现性，以及值得信赖的伙伴的存在。因此，我们不仅依赖科技，也同样重视由人提供的支持与沟通，从长期视角出发提供支持。',
      '今后，我们将继续从IT与金融两方面提供价值，努力成为在瞬息万变的时代中也能让客户安心选择的存在。',
    ],
    careerTitle: '履历',
    careerHistory: [
      '1994年　加入山一证券，于债券部担任期货期权交易员',
      '2007年　加入汇丰银行（HSBC），于个人金融本部担任面向高净值人群的投资顾问',
      '2017年　创立CJ投资株式会社',
    ],
    companyTitle: '企业信息',
    companyInfo: [
      {
        label: '公司名称',
        value: 'CJ投资株式会社（英文名称：CJ Investment Corporation）',
      },
      {
        label: '所在地',
        value: '〒222-0033　神奈川县横滨市港北区新横滨2-5-4 京浜建物第2大厦504',
      },
      { label: '注册资本', value: '1,000万日元' },
      { label: '成立时间', value: '2017年1月' },
      { label: '员工人数', value: '3名（截至2022年7月）' },
      { label: '往来银行', value: '骏河银行、湘南信用金库' },
    ],
    signRole: '代表董事',
    signName: '李 松',
  },
};
